/**
 * onl-api base URL (호스트).
 * order·payment 는 같은 호스트라 호출 path의 prefix(API_PREFIX)로 구분한다.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''

/** onl-api 서비스별 path prefix */
export const API_PREFIX = {
  ORDER: '/order/api/v2',
  PAYMENT: '/payment/api/v2',
} as const

/**
 * Mobile API host (예: dev-mobile-api.uglee.io).
 * 유저정보 조회 등 — onl-api와 다른 서버. 응답 envelope 없음.
 */
export const MOBILE_API_BASE_URL = import.meta.env.VITE_MOBILE_API_BASE_URL ?? ''

/** 토큰 없을 때 fallback 진입 페이지 (앱 메인) */
export const APP_REDIRECT_URL = 'https://www.sugeo.onl/'

/** PG SDK 키 — 환경별 public, 백엔드 환경변수 이름과 일치 */
export const NAVER_PAY_ONE_TIME_CLIENT_ID = import.meta.env.VITE_NAVER_PAY_ONE_TIME_CLIENT_ID ?? ''
export const NAVER_PAY_ONE_TIME_CHAIN_ID = import.meta.env.VITE_NAVER_PAY_ONE_TIME_CHAIN_ID ?? ''
export const NAVER_PAY_ONE_TIME_MODE = (import.meta.env.VITE_NAVER_PAY_ONE_TIME_MODE ?? 'development') as
  | 'production'
  | 'development'
export const TOSSPAYMENTS_QUICK_CLIENT_KEY = import.meta.env.VITE_TOSSPAYMENTS_QUICK_CLIENT_KEY ?? ''

/** Mixpanel */
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN ?? ''
export const MIXPANEL_DEBUG = import.meta.env.VITE_MIXPANEL_DEBUG === 'true'

/** 타임아웃 */
export const BRIDGE_READY_TIMEOUT_MS = 5000
export const API_TIMEOUT_MS = 10_000
